var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-editor-widget"},[_c('vue-editor',{attrs:{"placeholder":_vm.placeholder,"editorToolbar":_vm.customToolbar},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }